module.exports = __webpack_public_path__ + "img/popup-game-sucai.7fef1bba.png";